@if (label()) {
  <label for="">{{ label() }}</label>
}
@if (description()) {
  <div class="input-description">{{ description() }}</div>
}

@let selected = selectedValues();
@let trailingTemplate = trailingItemTemplate();
@let displayMode = itemDisplayMode();

@for (choice of choices(); track choice.value) {
  @if (multiSelect()) {
    <label class="checkbox-label" [class.tall-label]="displayMode === 'tall'">
      <input
        type="checkbox"
        [disabled]="isDisabled()"
        [checked]="selected.includes(choice.value)"
        (change)="toggleSelection(choice)"
      />
      <p class="hflex-100 fill-width flex-align-items-center flex-justify-content-space-between">
        {{ choice.label }}

        @if (trailingTemplate) {
          <ng-container
            *ngTemplateOutlet="trailingTemplate; context: { $implicit: choice }"
          ></ng-container>
        }
      </p>
    </label>
  } @else {
    <label class="radio-label" [class.tall-label]="displayMode === 'tall'">
      <input
        type="radio"
        [disabled]="isDisabled()"
        [checked]="selected.includes(choice.value)"
        (change)="toggleSelection(choice)"
      />
      <p class="hflex-100 fill-width flex-align-items-center flex-justify-content-space-between">
        {{ choice.label }}

        @if (trailingTemplate) {
          <ng-container
            *ngTemplateOutlet="trailingTemplate; context: { $implicit: choice }"
          ></ng-container>
        }
      </p>
    </label>
  }
}
@if (errorMessages.length > 0) {
  <div class="input-error">
    {{ errorMessages.join(', ') }}
  </div>
}
